$(document).ready(function () {
	'use strict';
	// navbar js start ---
	$(window).on('load scroll', function () {
		var scrolling = $(this).scrollTop();
		if (scrolling > 10) {
			$('.navbar').addClass('nav-fixed')
		} else {
			$('.navbar').removeClass('nav-fixed')
		}
	})

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".navbar-inner-bottom").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".navbar-inner-bottom").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper").toggleClass("active");
		$("body").toggleClass("active");
	});
	// navbar js end ---

	// collection-filter js start---
	$(".filter-open-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").addClass("active");
		$("body").addClass("active");
	});

	$(".filter-close-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").removeClass("active");
		$("body").removeClass("active");
	});
	// collection-filter js end---

	// collection tab js start---
	$('.collection-tab-link').click(function () {
		$('.collection-tab-link').removeClass('active');
		$(this).addClass('active');
		$('.tab-content-item').hide();

		var activeTab = $(this).attr('href');
		$(activeTab).fadeIn();
		return false;
	});


	$(".qty-increase").click(function () {
		$(".quantity-total").val(parseInt($(".quantity-total").val()) + 1);
	});

	$(".qty-decrease").click(function () {
		var currentValue = parseInt($(".quantity-total").val());
		if (currentValue > 1) {
			$(".quantity-total").val(currentValue - 1);
		}
	});

	// collection tab js end---

	// **..product-accordion js start..**
	$('.product-accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings().removeClass('active').find('.product-accordion-item-content').slideUp();
	});
	// **..product-accordion js end..**

	// mobile-dropdown responsive accordion js start--
	$(function () {
		let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

		if (isMobile) {
			// **..mobile-dropdown-accordion js start..**
			$('.dropdown-btn').on('click', function () {
				$(this).next(".dropdown-menu").slideToggle();
				$(this).toggleClass('active');
			});

			$('.sub-dropdown-btn').on('click', function () {
				$(this).next(".sub-dropdown-menu").slideToggle();
				$(this).toggleClass('active');
			});
			// **..mobile-dropdown-accordion js end..**
		}
	});
	// mobile-dropdown responsive accordion js end--

	
	$(".option_input").on('change', function () {
		var name = $(this).data('name');
		$('.selected_option').text(name);
	});

	$(".item-title").on('click', function () {
		$(this).next().toggleClass('show');
		$(this).parent().siblings().find('.filter-options-wrapper').removeClass('show');
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.collection-filter-item').length) {
		  $('.filter-options-wrapper').removeClass('show');
		}
	  });

	// Function to get combined selected option values
	function getSelectedOptions() {
		let optionName = '';

		// Get selected value from select
		let selectVal = $('.option_select').val();
		if (selectVal) {
			optionName += selectVal;
		}

		// Get selected values from radio inputs
		$('input:radio.option_input:checked').each(function () {
			optionName += optionName !== '' ? '-' : '';
			optionName += $(this).val();
		});

		return optionName;
	}

	// Change image / availability when product options change
	$('.option_input, .option_select').on('change', function () {
		let optionName = getSelectedOptions();

		// Find the matching variant
		$('#productSelect option').each(function () {
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var id = $(this).val();
				$('#productSelect').val(id);
				var available = $(this).data('available');

				const url = new URL(window.location.href);
				url.searchParams.set('variant', id);
				window.history.replaceState(null, null, url);

				if (available) {
					$('.atc_text').removeClass('sold_out').text('Ajouter au panier');
				} else {
					$('.atc_text').addClass('sold_out').text('Épuisé');
				}
			}
		});
	});


})

// showcase-banner slider js start---

/* var swiper = new Swiper(".showcase-banner-slider", {
	// effect: "fade",
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '">' + (index + 1) + "</span>";
		},
	},
}); */







// showcase-banner slider js end---

// home-banner slider js start----
/* var swiper = new Swiper(".home-banner-slider-thumb", {
	freeMode: true,
	loop: true,
	spaceBetween: 10,
	slidesPerView: 3,
	watchSlidesProgress: true,
});
var swiper2 = new Swiper(".home-banner-slider", {
	effect: "fade",
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	thumbs: {
		swiper: swiper,
	},
}); */
// home-banner slider js start----

// btn js ---
// primary btn---
/* $(function () {
	$('.primary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
}); */

// secondary btn--
$(function () {
	$('.secondary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});
// btn js ---


// modal js end---

$(document).ready(function(){

    // $('.filter-icon').on('click', function(){
    //    $('.collection-filter').addClass('active');
    // })

    // $('.filter-close').on('click', function(){
    //    $('.collection-filter').removeClass('active');
    // })


    // sort filter 
    $('.select_sort').on('change', function(){
        var sort = $(this).val();
        var coll = $('.collection_name').val();

        if( coll == 'products') {
            coll = 'all'
        } else {
            coll = $('.collection_name').val();
        }
        var option_name = '';
        $(".filter-item-checkbox:checked").each(function(index, element){
            if(index !== (length -1 )) {
                option_name += $(this).data('option') + '=';
                option_name += $(this).val() + '&';
            } else {
                option_name += $(this).data('option') + '=';
                option_name += $(this).val();
            }
        });
        if(option_name !='') {
            var url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort; 
            var filter_url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort;
            window.history.pushState({}, null, filter_url);
            filter_update(url);
        }else{
            var url = '/collections/' + coll + '?sort_by=' + sort; 
            var filter_url = '/collections/' + coll + '?sort_by=' + sort;
            window.history.pushState({}, null, filter_url);
            filter_update(url);
        }
        
    });
});


function sortCheck(e, el) {
    var sort = $(el).val();
    var coll = $('.collection_name').val();

    if( coll == 'products') {
        coll = 'all'
    } else {
        coll = $('.collection_name').val();
    }
    var option_name = '';
    $(".filter-item-checkbox:checked").each(function(index, element){
        if(index !== (length -1 )) {
            option_name += $(this).data('option') + '=';
            option_name += $(this).val() + '&';
        } else {
            option_name += $(this).data('option') + '=';
            option_name += $(this).val();
        }
    });
    if(option_name !='') {
        var url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort; 
        var filter_url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort;
        window.history.pushState({}, null, filter_url);
        filter_update(url);
    }else{
        var url = '/collections/' + coll + '?sort_by=' + sort; 
        var filter_url = '/collections/' + coll + '?sort_by=' + sort;
        window.history.pushState({}, null, filter_url);
        filter_update(url);
    }
}

function filterCheck() {
	var length = $('.filter-item-checkbox:checked').length;
	var sort = $('.select_sort').val();
	var coll = $('.collection_name').val();

	var option_name = $('.filter-item-checkbox:checked').map(function () {
		return $(this).data('option') + '=' + $(this).val();
	}).get().join('&');

	$('.added_filter').text(length);

	var base_url = '/collections/' + coll + '?';
	var url = base_url + (option_name ? option_name + '&' : '') + 'sort_by=' + sort;
	var filter_url = coll + '?' + (option_name ? option_name + '&' : '') + 'sort_by=' + sort;

	window.history.pushState({}, null, filter_url);
	filter_update(url);

	// ==========================
	// Update selected filter items
	// ==========================
	var selectedItemsContainer = $('.filter-selected-items');
	selectedItemsContainer.empty(); // Clear existing items

	$('.filter-item-checkbox:checked').each(function () {
		var labelText = $(this).next('label').text();
		var filterID = $(this).attr('id');

		var selectedItem = `
            <div class="filter-selected-item">
                <p class="filter-selected-item-text">${labelText}</p>
                <button class="remove-selected-filter" data-filter-id="${filterID}">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.5 1.5L1.5 8.5M1.5 1.5L8.5 8.5" stroke="#FDF8F0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        `;
		selectedItemsContainer.append(selectedItem);
	});
}

// Modifiez la fonction filter_update pour initialiser les animations après le chargement
function filter_update(url) {
	fetch(url)
		.then(response => response.text())
		.then(infoData => {
			var productsSection = $(infoData).find('.collection-product-wrap'); // Fetch products + pagination
			$('.collection-product-wrap').replaceWith(productsSection); // Replace full section

			// Réinitialiser les animations de défilement
			if (typeof initializeScrollAnimationTrigger === 'function') {
				// Ajouter la classe offscreen aux nouveaux éléments
				const animationTriggerElements = document.querySelectorAll('.scroll-trigger');
				animationTriggerElements.forEach(element => {
					element.classList.add('scroll-trigger--offscreen');
				});

				// Réinitialiser les animations
				initializeScrollAnimationTrigger();

				// Réinitialiser les animations de zoom si nécessaire
				if (typeof initializeScrollZoomAnimationTrigger === 'function') {
					initializeScrollZoomAnimationTrigger();
				}
			}

			// Initialiser les animations fade-in
			initFadeInAnimations();
		});
}

// Fonction pour initialiser les animations fade-in
function initFadeInAnimations() {

	// Sélectionner tous les éléments avec la classe fade-in
	const fadeElements = document.querySelectorAll('.fade-in');

	// Observer l'intersection pour déclencher l'animation quand l'élément est visible
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			// Si l'élément est visible
			if (entry.isIntersecting) {
				// Ajouter une classe pour déclencher l'animation
				setTimeout(() => {
					entry.target.classList.add('visible');
				}, parseInt(entry.target.dataset.delay || 0));

				// Arrêter d'observer cet élément
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.1 }); // Déclencher quand au moins 10% de l'élément est visible

	// Observer chaque élément fade-in
	fadeElements.forEach((element, index) => {
		// Réinitialiser l'état de l'animation
		element.classList.remove('visible');

		// Ajouter un délai progressif si nécessaire
		if (element.parentElement && element.parentElement.dataset.moduleDelayIncrement) {
			const increment = parseInt(element.parentElement.dataset.moduleDelayIncrement);
			element.style.setProperty('--module-delay', `${index * increment}ms`);
		}

		observer.observe(element);
	});
}
// Fonction pour initialiser les animations de défilement
function initializeScrollAnimationTrigger() {

	const animationTriggerElements = document.querySelectorAll('.scroll-trigger');

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.remove('scroll-trigger--offscreen');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.1 });

	animationTriggerElements.forEach(element => {
		element.classList.add('scroll-trigger--offscreen');
		observer.observe(element);
	});
}

// Fonction pour initialiser les animations de zoom
function initializeScrollZoomAnimationTrigger() {

	const zoomElements = document.querySelectorAll('.zoom-trigger');

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('zoom-trigger--active');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.1 });

	zoomElements.forEach(element => {
		element.classList.remove('zoom-trigger--active');
		observer.observe(element);
	});
}

// Initialiser les animations au chargement de la page
$(document).ready(function() {
	// Initialiser les animations au chargement de la page
	if (typeof initializeScrollAnimationTrigger === 'function') {
		initializeScrollAnimationTrigger();
	}

	if (typeof initializeScrollZoomAnimationTrigger === 'function') {
		initializeScrollZoomAnimationTrigger();
	}

	initFadeInAnimations();
});

// remove selected filter on click
$(document).on('click', '.remove-selected-filter', function () {
    var filterID = $(this).data('filter-id');
    $('#' + filterID).prop('checked', false);
    filterCheck();
});


function filterActive(e,el){
    $(el).next().slideToggle(); 
    $(el).toggleClass('inactive');
}